<!--
  ~ Copyright (c) $year. Rondafel
  -->

<div class="container">
    <div class="row">
        <div class="col-md-6 col-md-offset-3">
            <div class="panel panel-login">
                <div class="panel-heading">
                    <div class="row">
                        <div class="form-header">
                            <a href="#" class="active" id="login-form-link">Login</a>
                        </div>
                    </div>
                    <hr>
                </div>
                <div id="login-panel">
                    <div class="row">
                        <div class="col-lg-12">
                            <form #loginForm="ngForm" id="login-form" method="POST" role="form"
                                  (ngSubmit)=onSubmit(loginForm) style="display: block;">
                                <div class="form-group">
                                    <input type="text" [(ngModel)]="loginUser.username" required name="username"
                                           id="username" tabindex="1" class="form-control" placeholder="Username" value="">
                                </div>
                                <div class="form-group">
                                    <input type="password" [(ngModel)]="loginUser.password" required name="password"
                                           id="password" tabindex="2" class="form-control" placeholder="Password">
                                </div>
                                <div *ngIf="!authSuccess">{{authErrorMsg}}</div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-6 col-sm-offset-3">
                                            <button class="form-control btn btn-login" id="login-button" type="submit"
                                                    [disabled]="!loginForm.valid">Login</button>
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>